import { Map } from 'immutable';

export function update(state, action) {
    if (!action.data.id) {
        action.data.id = action.id;
    }

    return bulk(
        state,
        {
            data: [
                action.data
            ]
        }
    );
}

export function bulk(state, action) {
    let items = state.get('items');

    action.data.forEach((audit) => {
        let item = items.get(+audit.id) || Map();
        items = items.set(+audit.id, item.merge(audit));
    });

    return state.set('items', items);
}
